define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/dom-construct",
    "csi/_base/underscore",
    "csi/def",
    "csi/def/Field",
    "csi/form/Widget",
    "csi/html",
    "csi/locale",
    "csi/reflection",
    "csi/xml"
], function(declare,lang,domConstruct,_,def,Field,Widget,html,locale,reflection,xml) {
    // If modifying this behavior also update SiteAdmin/CopyTemplateForm.js

    return declare(Widget, {

        _resolveView: function() {
            // summary: add fields for options if not already there
            this.inherited(arguments);

            var copyTemplateNode = this.getFormSourceNode();
            if (!copyTemplateNode)
                return;

            // Copy node class and localization map
            var rc = reflection.getNodeClass(copyTemplateNode);
            var lmap = this.defView.getLocaleMap(rc);

            // Add metadata fields
            _.each([].concat(this.defView.m_fields),function(field){
                // Locked
                field._lockedField = this._addMetaDataField(copyTemplateNode, field.m_id + "Locked");
                field._lockedField.resolve(lmap, rc, copyTemplateNode);
            }, this);
        },

        _addMetaDataField: function(/*Node*/node, /*String*/id) {
            var f = lang.mixin(new Field(), {
                m_id: id,
                m_name: id,
                m_typeControl: def.FIELD_CHECKBOX,
                _metaDataField: true
            });

            this.addDefaultValue(id, node[id]);
            this.insertField(f);

            return f;
        },

        _buildField: function(/*Context*/ctx, /*Field*/field, /*DOMNode*/tr, /*DOMNode?*/tdControl) {
            // summary: add additional Locked meta data fields

            // don't add the metadata field as a regular field
            if (field._metaDataField)
                return;

            this.inherited(arguments);

            if (field.m_id == xml.ATTR_NAME || field.m_id == "Subtype")
                return;

            if (tr == tr.parentNode.firstChild) {
                // add meta data headers
                html.create("th", {
                    innerText: locale.resource("Copy-Locked"),
                    style: "padding: 0 10px"
                }, tr);
            }

            // add Locked metadata fields if exist
            this._buildMetaDataField(ctx, field._lockedField, tr);
        },

        _buildMetaDataField: function(/*Context*/ctx, /*Field*/f, /*DOMNode*/tr) {
            if (f) {
                Widget.prototype._buildField.call(this, ctx, f, tr, domConstruct.create("th", {style:"text-align:center"}, tr));
            }
        },

        _buildFields: function(/*Field[]*/fields) {
            // summary: build header field
            fields.unshift(lang.mixin(new Field(), {
                m_label: "",
                m_typeControl: def.FIELD_COMMENT
            }));

            this.inherited(arguments);
        }
    });
});